module.exports = __webpack_public_path__ + "img/medal-ranking.9c97293b.svg";